import { Stack, Typography, styled } from '@mui/material';

export const AuthCardStyled = styled(Stack)(({ theme }) => ({
  minWidth: 656,
  borderRadius: theme.spacing(1),
  background: theme.palette.white.main,
  padding: theme.spacing(4),
  gap: theme.spacing(2),
}));

export const TitleLogin = styled(Typography)(({ theme }) => ({
  fontSize: theme.spacing(3),
  fontWeight: '700',
  lineHeight: theme.spacing(4.5),
  letterSpacing: '0px',
  textAlign: 'left',
  color: theme.palette.primary.main,
}));
